<button type="button" class="btn btn-sm btn-light hs-lm-item-visibility"
  [ngClass]="dataset.included ? 'hs-checkmark' : 'hs-uncheckmark'"
  (click)="dataset.included = !dataset.included;$event.stopPropagation()"></button>
<!--span class="glyphicon cursor-pointer text-secondary"
  [ngClass]="descriptionVisible ? 'icon-chevron-down' : 'icon-chevron-right'"
  (click)="descriptionVisible = !descriptionVisible"></span-->
<label class="ps-2 text-secondary"><a class="text-decoration-none"
    (click)="dataset.included = !dataset.included;$event.stopPropagation()">{{getLabelInCurrentLang(dataset.labels)}}</a></label>
&nbsp;
<i class="icon-opennewwindow cursor-pointer text-info" (click)="showMetadataWindow(dataset)"></i>
<!--div class="p-2 mb-2 text-info" [hidden]="!descriptionVisible">
  {{dataset.desc}}
</div-->
